<div class="direct-plan-grid-item" fxLayoutAlign="start start" fxLayoutGap="8px">
  <sbnb-icon
    *ngIf="!negative"
    fxFlex="0 0 18px"
    class="direct-plan-grid-item-icon"
    icon="check"
    [ngClass]="{
      'text-grass-darker': included,
      'text-smoke-darker': !included
    }"></sbnb-icon>

  <img *ngIf="negative" fxFlex="20px" src="/assets/iconography/delete.svg" alt="Cross" />

  <span *ngIf="descriptionKey" class="direct-plan-grid-item-description">{{ descriptionKey }}</span>

  <span *ngIf="!descriptionKey" class="direct-plan-grid-item-description">
    <ng-content></ng-content>
  </span>
</div>
